const StringToColor = require('string-to-color');

function componentToHex(c: number): string {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
}

export function rgbToHex(input: {r: number; g: number; b: number}): string {
    return '#' + componentToHex(input.r) + componentToHex(input.g) + componentToHex(input.b);
}

function hexToRgb(hex: string): {r: number; g: number; b: number} | null {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result
        ? {
              r: parseInt(result[1], 16),
              g: parseInt(result[2], 16),
              b: parseInt(result[3], 16),
          }
        : null;
}

//https://stackoverflow.com/a/43235
export function mixColors(first: string, second: string): {r: number; g: number; b: number} {
    const firstRgb = hexToRgb(first);
    const secondRgb = hexToRgb(second);

    if (firstRgb === null || secondRgb === null) {
        throw new Error();
    }

    return {
        r: Math.floor((firstRgb.r + secondRgb.r) / 2),
        g: Math.floor((firstRgb.g + secondRgb.g) / 2),
        b: Math.floor((firstRgb.b + secondRgb.b) / 2),
    };
}

function increaseContrast(
    input: {r: number; g: number; b: number},
    percentage: number,
): {r: number; g: number; b: number} {
    // Clamp the percentage between -100 and 100
    const pct = Math.max(-100, Math.min(percentage, 100));

    // Calculate the contrast factor
    const factor = (259 * (pct + 255)) / (255 * (259 - pct));

    // Helper to adjust each channel
    const adjust = (color: number): number => {
        const newColor = factor * (color - 128) + 128;
        return Math.round(Math.max(0, Math.min(255, newColor)));
    };

    return {
        r: adjust(input.r),
        g: adjust(input.g),
        b: adjust(input.b),
    };
}

export const accentColor = '#3AC2E7';

export function stringToColorHex(input: string): string {
    return rgbToHex(increaseContrast(mixColors(accentColor, StringToColor(input)), 40));
}
